import { Link } from 'react-router-dom';

const footerLinks = {
  内容分类: [
    { name: '日韩影视', path: '/category?tab=drama' },
    { name: '日韩音乐', path: '/category?tab=music' },
    { name: '日韩综艺', path: '/category?tab=variety' },
    { name: '娱乐资讯', path: '/category?tab=news' },
  ],
  关于我们: [
    { name: '品牌介绍', path: '/about' },
    { name: '用户口碑', path: '/about' },
    { name: '联系方式', path: '/about' },
    { name: '常见问题', path: '/about' },
  ],
  法律信息: [
    { name: '服务条款', path: '/about' },
    { name: '隐私政策', path: '/about' },
    { name: '版权声明', path: '/about' },
  ],
};

const socialLinks = [
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-bilibili-line', label: 'B站' },
  { icon: 'ri-links-line', label: '抖音' },
  { icon: 'ri-reddit-line', label: '小红书' },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-sun-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">日韩在线</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-xs">
              正版日韩内容一站聚合平台。最新影视、热门音乐、爆笑综艺、深度资讯，无需翻墙，极速流畅播放。
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/60 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                  title={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2024-2026 日韩在线 Rikkan Online. All Rights Reserved.
          </p>
          <p className="text-xs text-background-500">
            <Link to="/about" className="hover:text-background-300 transition-colors cursor-pointer">京ICP备2024XXXXXXXX号</Link>
            <span className="mx-2">|</span>
            <span>京公网安备 1101050203XXXX号</span>
          </p>
        </div>
      </div>
    </footer>
  );
}